import React from 'react'
import { Link } from 'react-router'
import { compose } from 'redux'
import styles from './styles'
import withStyles from 'constructicon/with-styles'
import withToggle from 'constructicon/with-toggle'

import Buttons from '../../ui/Buttons'
import HeaderContainer from './HeaderContainer'
import Icon from 'constructicon/icon'
import Image from '../../ui/Image'
import Navigation from '../Navigation'

const Header = ({
  background = 'light',
  bannerOverlay,
  classNames,
  ctas,
  foreground = 'dark',
  logo = {},
  logoLink = {},
  logoSize = 'small',
  navigation,
  onToggle,
  onToggleOff,
  shadow,
  sticky,
  poweredBy,
  styles,
  toggled
}) => {
  const logoHeight = logoSizes[logoSize]

  return (
    <HeaderContainer
      background={background}
      foreground={foreground}
      hasShadow={shadow === 'yes'}
      height={logoHeight}
      isNavOpen={toggled}
      isOverlaid={bannerOverlay === 'yes'}
      isSticky={sticky === 'yes'}
      poweredBy={poweredBy}
    >
      <div className={classNames.container}>
        {logoLink.url ? (
          <a className='ssb-logo' href={logoLink.url}>
            <Image
              maxHeight={logoHeight}
              image={{ url: logo.url, alt: logo.alt || 'Site logo' }}
            />
          </a>
        ) : (
          <Link className='ssb-logo' to='/'>
            <Image
              maxHeight={logoHeight}
              image={{ url: logo.url, alt: logo.alt || 'Site logo' }}
            />
          </Link>
        )}

        <button
          aria-hidden
          aria-label='Toggle menu'
          onClick={onToggle}
          className={classNames.toggle}
        >
          <Icon name={toggled ? 'close' : 'menu'} size={1} />
        </button>
        <div className={classNames.nav}>
          <Navigation
            items={navigation}
            onClick={onToggleOff}
          />
          <Buttons
            buttons={ctas}
            onClick={onToggleOff}
          />
        </div>
      </div>
    </HeaderContainer>
  )
}

const logoSizes = {
  tiny: 1.5,
  small: 2,
  medium: 3,
  large: 4
}

export default compose(withToggle, withStyles(styles))(Header)
